import Api from '@/services/Api';

export default {
  getAllTentacles() {
    return Api().get('/tentacles');
  },
  getTentacleByID(id) {
    return Api().get(`/tentacles/${id}`);
  },
  getTentacleByType(typeID, customerId) {
    return Api().get(`/tentacles?type=${typeID}&customer=${customerId}`);
  },
  updateTentacles(data) {
    return Api().patch('/tentacles', data);
  },
  getTentacleTypes(customerId) {
    return Api().get(`/tentacle/types?customer=${customerId}`);
  },
  checkSigfoxCoverage(lat,lng) {
    return Api().get(`/tentacle/coverage?lat=${lat}&lng=${lng}`);
  },
};
